import {
  CampaignAnalyticsReport,
  ChartTypeName,
} from '@components/Dashboard/CampaignAnalytics/slice/schema';

const PAGE_WIDTH = 1280;
const PAGE_ASPECT_RATIO = 16 / 9;
const PAGE_HEIGHT = PAGE_WIDTH / PAGE_ASPECT_RATIO;
const PAGE_MARGIN_LEFT = 40;
const PAGE_MARGIN_TOP = 100;
const PAGE_BREAK_CUTOFF = 40;

export const CHART_WIDTH = PAGE_WIDTH - PAGE_MARGIN_LEFT * 4;
const CHART_HEIGHT_MAX = PAGE_HEIGHT - PAGE_MARGIN_TOP - PAGE_BREAK_CUTOFF * 4;
const LINE_HEIGHT = 16;

export const getChartHeight = (
  chart: CampaignAnalyticsReport[ChartTypeName]
): number => {
  const takeawaysCount = chart.takeaways.length;
  const recommendationsCount = chart.recommendations
    ? chart.recommendations.length
    : 0;

  return (
    CHART_HEIGHT_MAX -
    takeawaysCount * LINE_HEIGHT -
    (recommendationsCount ? recommendationsCount + 1 : 0) * LINE_HEIGHT
  );
};
